import { render, staticRenderFns } from "./my-editor-view.vue?vue&type=template&id=642a8c80&scoped=true&"
import script from "./my-editor-view.vue?vue&type=script&lang=js&"
export * from "./my-editor-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642a8c80",
  null
  
)

export default component.exports